import { defineMessages, useIntl } from 'react-intl';

import { Tabs } from '../../Shared/Tabs';
import { PeopleWithAccess } from './PeopleWithAccess';
import { PreviewMembers } from './PreviewMembers';
import type { PeopleWithAccessProps, PreviewMembersProps } from './ShareModal';

type ShareModalContentProps =
  | ({
      view: 'previewMembers';
    } & PreviewMembersProps)
  | ({
      view: 'peopleWithAccess';
    } & PeopleWithAccessProps);

const messages = defineMessages({
  shareCollection: {
    defaultMessage: 'Share Collection',
    id: 'xj+IYa',
  },
});

export function ShareModalContent(props: ShareModalContentProps) {
  const { formatMessage } = useIntl();
  if (props.view === 'peopleWithAccess') {
    return (
      <Tabs
        tabs={[
          {
            id: 'shareCollection',
            title: formatMessage(messages.shareCollection),
            content: <PeopleWithAccess {...props} />,
          },
        ]}
        selectedTab="shareCollection"
        onTabChange={() => {}}
      />
    );
  }

  return <PreviewMembers {...props} />;
}
